export interface MacroAuditItem {
  id: string;
  indicator_id?: string;
  nameKo: string;
  nameEn: string;
  market: 'US' | 'KR';
  cachedVal: number | null;
  sourceVal: number | null;
  diff: number | null;
  status: 'PASS' | 'WARN' | 'FAIL';
  issueType: 'STALE' | 'OUT_OF_BOUNDS' | 'SPIKE' | 'MISMATCH' | 'DIVISOR_ERROR' | 'NONE';
  message: string;
  indicatorDate: string | null;
  releaseDate: string | null;
}

export interface MacroAuditResponse {
  success: boolean;
  lastAuditedAt: string | null;
  stats: {
    totalCount: number;
    passCount: number;
    warnCount: number;
    failCount: number;
    accuracyRate: number;
  };
  audits?: any[];
  results?: any[];
}

export const fetchMacroAuditStatus = async (market: string = 'ALL'): Promise<MacroAuditResponse> => {
  try {
    const res = await fetch(`/api/macro/audit?market=${market}`);
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    return await res.json();
  } catch (err: any) {
    console.error('Failed to fetch macro audit status:', err);
    return {
      success: false,
      lastAuditedAt: null,
      stats: { totalCount: 0, passCount: 0, warnCount: 0, failCount: 0, accuracyRate: 100 },
      audits: []
    };
  }
};

export const runMacroAudit = async (indicators?: any): Promise<MacroAuditResponse> => {
  try {
    const res = await fetch('/api/macro/audit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ indicators })
    });
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    return await res.json();
  } catch (err: any) {
    console.error('Failed to run macro audit:', err);
    throw err;
  }
};
